module.exports = __webpack_public_path__ + "static/media/yay.52ce314d.svg";